import { Modal, ModalBody, ModalHeader } from "flowbite-react";
import { HELP_COPY } from "@/features/auth/config/loginHelp.config";

type LoginHelpDialogProps = {
  isOpen: boolean
  onClose: () => void
};

const CONTACTS = [
  { label: HELP_COPY.SUPPORT_LABEL, email: HELP_COPY.SUPPORT_EMAIL },
  { label: HELP_COPY.PRIVACY_LABEL, email: HELP_COPY.PRIVACY_EMAIL },
] as const;

// The help center is only reachable once logged in: the login shows the
// contacts instead.
export const LoginHelpDialog = ({ isOpen, onClose }: LoginHelpDialogProps) => (
  <Modal show={isOpen} dismissible onClose={onClose} size="md">
    <ModalHeader>{HELP_COPY.TITLE}</ModalHeader>
    <ModalBody className="space-y-4">
      <p className="text-sm leading-6 text-gray-600 dark:text-gray-300">{HELP_COPY.MESSAGE}</p>
      <dl className="space-y-2">
        {CONTACTS.map((contact) => (
          <div key={contact.email} className="flex items-center justify-between gap-4 rounded-xl bg-gray-50 px-4 py-3 dark:bg-gray-800">
            <dt className="text-sm text-gray-600 dark:text-gray-300">{contact.label}</dt>
            <dd><a href={`mailto:${contact.email}`} className="text-sm font-semibold text-primary">{contact.email}</a></dd>
          </div>
        ))}
      </dl>
    </ModalBody>
  </Modal>
);

LoginHelpDialog.displayName = "LoginHelpDialog";
